import { AccommodationLandingPageContentResponseModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import Markup from '@shared/components/Markup.tsx';
import BookingObjectsListDescendants from '@my-pages/features/object-booking/components/BookingObjectsListDescendants.tsx';

interface IAccommodationLandingPage {
    content: AccommodationLandingPageContentResponseModel;
}

const AccommodationLandingPage = ({ content }: IAccommodationLandingPage) => {
    return (
        <>
            <h1 className='page-title'>{content.properties?.heading ?? content.name}</h1>
            {content.properties?.body && content.properties.body.markup ? (
                <div className='slide-up-fade-in mb-4'>
                    <div className='row'>
                        <div className='col-xl-8'>
                            <Markup content={content.properties.body.markup} />
                        </div>
                    </div>
                </div>
            ) : null}
            {content.id ? <BookingObjectsListDescendants contentId={content.id} /> : null}
        </>
    );
};

export default AccommodationLandingPage;
